import React from "react";
import { MapPin, Phone, Mail } from "lucide-react";

const phoneNumber = "+919876543210";
const phoneNumber2 = "+918765432109";
const email = "anmolfurniturebazaar@gmail.com";
const mapUrl =
  "https://maps.google.com/maps?q=Anmol+Furniture+Bazar,+Virar+East,+Thane,+Maharashtra+401305";

const Contact: React.FC = () => (
  <div className="container mx-auto px-4 py-12">
    <h1 className="text-3xl font-bold mb-6 text-primary-900">Contact Us</h1>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
      {/* Contact Info */}
      <div className="space-y-6">
        <div className="flex items-center space-x-3">
          <MapPin className="w-6 h-6 text-primary-600" />
          <div>
            <p className="font-semibold text-gray-900">Anmol Furniture Bazar</p>
            <p className="text-gray-700">Virar East, Thane, Maharashtra 401305</p>
            <a
              href={mapUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary-600 hover:underline text-sm"
            >
              View on Google Maps
            </a>
          </div>
        </div>
        <div className="flex items-center space-x-3">
          <Phone className="w-6 h-6 text-primary-600" />
          <div>
            <a
              href={`tel:${phoneNumber}`}
              className="text-primary-600 font-semibold hover:underline"
            >
              Call Now: {phoneNumber.replace("+91", "+91 ")}
            </a>
            <br />
            <a
              href={`tel:${phoneNumber2}`}
              className="text-primary-600 font-semibold hover:underline"
            >
              {phoneNumber2.replace("+91", "+91 ")}
            </a>
          </div>
        </div>
        <div className="flex items-center space-x-3">
          <Mail className="w-6 h-6 text-primary-600" />
          <a
            href={`mailto:${email}`}
            className="text-primary-600 font-semibold hover:underline"
          >
            Mail Now: {email}
          </a>
        </div>
        <div className="mt-6">
          <h4 className="font-semibold mb-2 text-primary-800">Business Hours</h4>
          <div className="text-sm text-gray-700 space-y-1">
            <p>Mon - Sat: 9:00 AM - 8:00 PM</p>
            <p>Sunday: 10:00 AM - 6:00 PM</p>
          </div>
        </div>
      </div>
      {/* Embedded Google Map */}
      <div>
        <iframe
          title="Anmol Furniture Bazar Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3768.019660497795!2d72.81000031539652!3d19.46200098687659!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b0e6e6e6e6e6%3A0x123456789abcdef!2sAnmol%20Furniture%20Bazar!5e0!3m2!1sen!2sin!4v1690000000000!5m2!1sen!2sin"
          width="100%"
          height="350"
          style={{ border: 0, borderRadius: "12px" }}
          allowFullScreen
          loading="lazy"
        ></iframe>
      </div>
    </div>
  </div>
);

export default Contact;